<div class="flex flex-col gap-3 pb-3" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <y42-range-picker class="flex justify-end" [ranges]="ranges" (rangeSelected)="selectRange($event)"></y42-range-picker>

  <div class="flex flex-col items-center gap-3">
    <y42-date-picker
      [selectedRange]="state.dateRange"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [pickSingleDate]="singleDatePicker"
      [startAt]="state.dateRange.start"
      (dateChanged)="changeDate($event)"
    ></y42-date-picker>
    <y42-time-selector
      *ngIf="timePicker"
      [time]="state.startTime"
      [minTime]="state.timeRestrictions.startTime.minTime"
      [maxTime]="state.timeRestrictions.startTime.maxTime"
      (timeChanged)="changeStartTime($event)"
    ></y42-time-selector>
  </div>
  <div *ngIf="!singleDatePicker" class="flex flex-col items-center gap-3">
    <y42-date-picker
      [selectedRange]="state.dateRange"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [startAt]="state.startAt"
      (dateChanged)="changeDate($event)"
    ></y42-date-picker>
    <y42-time-selector
      *ngIf="timePicker"
      [time]="state.endTime"
      [minTime]="state.timeRestrictions.endTime.minTime"
      [maxTime]="state.timeRestrictions.endTime.maxTime"
      (timeChanged)="changeEndTime($event)"
    >
    </y42-time-selector>
  </div>
  <div *ngIf="state.timezoneDiffInfo.isDifferentTimezone" class="w-full flex items-center justify-center text-gray-700">
    <span class="font-bold">Timezone</span>
    <fa-icon
      [icon]="['fal', 'info-circle']"
      class="ml-1 cursor-pointer"
      [matTooltip]="state.timezoneDiffInfo.tooltipInfo"
    ></fa-icon>
  </div>
</div>
